import { Component, h, Host, Element, State } from '@stencil/core';

@Component({
  tag: 'spw-header-lang',
  styleUrl: 'spw-header-lang.scss',
  shadow: true,
})
export class SpwHeaderLang {
  @Element() el!: HTMLElement;
  @State() activeLang: string = '';

  componentWillLoad() {
    this.updateActiveLang();
  }

  updateActiveLang() {
    const items = this.el.querySelectorAll('spw-header-lang-item');
    items.forEach((item: HTMLElement) => {
      if (item.getAttribute('active') === 'true') {
        this.activeLang = item.getAttribute('lang') || '';
      }
    });
  }

  handleSelect(lang: string) {
    this.activeLang = lang;
    const items = this.el.querySelectorAll('spw-header-lang-item');
    items.forEach((item: HTMLElement) => {
      item.setAttribute('active', item.getAttribute('lang') === lang ? 'true' : 'false');
    });
  }

  render() {
    return (
      <Host>
        <div class="spw-header-lang">
          <spw-button variant="secondary" icon="fa-chevron-down" class="spw-header-lang__active-lang">
            {this.activeLang}
          </spw-button>
          <div class="spw-header-lang__dropdown">
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
